import { FormLabel, Input, Select, VStack, Wrap } from "@chakra-ui/react";
import FormInputWraper from "../../Components/FormInputWrapper";
import type { FormStepProps } from "../../interfaces";
import { INPUT_SIZE, INPUT_VARIANT } from "../../RegisterPage";
import { useTranslations } from "next-intl";

const BirthdayInput = ({ FormController }: FormStepProps) => {
  const t = useTranslations("pages.register");
  return (
    <VStack spacing={1} align="stretch" w="full">
      <FormLabel>{t("birthday")}</FormLabel>
      <Wrap direction={"row"} w="full" spacing={5}>
        <FormInputWraper
          flex={1}
          FormController={FormController}
          field_name="bday_day"
          color="brandOrange.500"
          isRequired
        >
          <Input
            placeholder={t("dayPlaceholder")}
            variant={INPUT_VARIANT}
            size={INPUT_SIZE}
            type="number"
            {...FormController.register("bday_day", {
              required: t("dayOfBirthInputMessage"),
            })}
          />
        </FormInputWraper>

        <FormInputWraper
          flex={1}
          FormController={FormController}
          field_name="bday_month"
          color="brandOrange.500"
          isRequired
        >
          <Select
            flex={1}
            {...FormController.register("bday_month", {
              required: t("monthOfBirthInputMessage"),
            })}
            variant={INPUT_VARIANT}
            size={INPUT_SIZE}
          >
            <option value="" disabled>
              {t("month")}
            </option>
            <option value="01">{t("jan")}</option>
            <option value="02">{t("fev")}</option>
            <option value="03">{t("mar")}</option>
            <option value="04">{t("apr")}</option>
            <option value="05">{t("may")}</option>
            <option value="06">{t("jun")}</option>
            <option value="07">{t("jul")}</option>
            <option value="08">{t("aug")}</option>
            <option value="09">{t("sep")}</option>
            <option value="10">{t("oct")}</option>
            <option value="11">{t("nov")}</option>
            <option value="12">{t("dec")}</option>
          </Select>
        </FormInputWraper>
        <FormInputWraper
          flex={1}
          FormController={FormController}
          field_name="bday_year"
          color="brandOrange.500"
          isRequired
        >
          <Input
            flex={1}
            placeholder={t("yearPlaceholder")}
            variant={INPUT_VARIANT}
            size={INPUT_SIZE}
            type="number"
            {...FormController.register("bday_year", {
              required: t("yearOfBirthInputMessage"),
              min: {
                value: 1930,
                message: t("minRequiredYearMessage")
              },
              max: {
                value: new Date().getFullYear(),
                message: t("maxRequiredYearMessage")
              },
            })}
          />
        </FormInputWraper>
      </Wrap>
    </VStack>
  );
};

export default BirthdayInput;
